import { authApi, formData } from "utils";

export const saveUserGeneralSettings = (settings) => () =>
    authApi.post(`/settings/shop/general`, formData(settings)).then(res => {
        if (res.status === 200) {
            return res
        } else {
            throw res
        }
    }).catch(err => {
        throw err
    })


export const saveShopDesignSettings = (settings) => () =>
    authApi.post(`/settings/shop/design`, formData(settings))
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        }).catch(err => {
        throw err
    })


export const saveUserNotificationSettings = (settings) => () =>
    authApi.post(`/settings/user/notifications`, formData(settings)).then(res => {
        if (res.status === 200) {
            return res
        } else {
            throw res
        }
    }).catch(err => {
        throw err
    })


export const savePayments = (settings) => () =>
    authApi.post(`/settings/shop/payments`, formData(settings)).then(res => {
        if (res.status === 200) {
            return res
        } else {
            throw res
        }
    }).catch(err => {
        throw err
    })

export const saveShopTermsSettings = (terms_of_service) => () =>
    authApi.post(`/settings/shop/terms`, formData({ terms_of_service }))
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        }).catch(err => {
        throw err
    })


export const completeSetup = () => () =>
    authApi.post(`/settings/complete_setup_wizard`)
        .then(res => {
            if (res.status === 200) {
                return res
            } else {
                throw res
            }
        }).catch(err => {
        throw err
    })

